import gql from 'graphql-tag';

export const CHECK_SOLUTION_HEALTH = gql`
    query {
        checkSolutionHealth
    }
`;